import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  // Grid,
  Stack,
  Typography,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Grid from "@material-ui/core/Grid";
import MuiCheckMark from "./helperComponent/MuiCheckMark";

import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import {
  setNotificationMessage,
  setWindowReference,
} from "./payment-reducer/actions";
import { messages } from "./messages";
import { NotificationType } from "./Utils";
import { applyCouponCode, buyPackage, getMySubscription } from "../../paymentRequest";
import {
  FEATURE_CUSTOM_REDUX,
  FEATURE_CUSTOM_PAYMENT,
  FEATURE_CUSTOM_REDUX_V3,
} from "../../../constant";
import ButtonLoader from "./helperComponent/ButtonLoader";
import { getBaseConfig, getStore, handlePaymentWindow } from "../../../Utils";
import toast from "react-simple-toasts";
import { stripeMessage } from "../../messages";
import ConfirmationAlert from "./ConfirmationAlert";
import { CURRENT_ROOM_NAME } from "../../../../webjam/constant";
import { LoadingButton } from "@atlaskit/button";
import { GenericConfirmationModal } from "../../../../../features/customise/custom/components/GenericConfirmationModal";
import { ct, dynamicMessageLocale } from "../../../constant-Utils";
import { getTranslatedSubsName } from ".";
import i18next from "i18next";
import { setConfirmationModalProps, setManualBoxProcess, setShowDevicePreConnection } from "../../../redux/tool-webjam-v3/actions";
import { addDeviceBox } from "../../Request.d";
import { setData } from "../../../redux/tool-webjam/actions";

const RCard = (props) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const cardHeight = isMobile ? "350px" : "500px";
  const [expanded, setExpanded] = React.useState(false);
  const [isConfirming, setIsConfirming] = useState(false)
  const [openMobileModal, setOpenMobileModal] = useState(false);
  const [checkoutUrl, setCheckoutUrl] = useState("");
  // const [features, setFeatures] = React.useState([])

  const [isPurchased, setIsPurchased] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [recheckUserSubscription, setReCheckUserSubscription] = useState(false);

  const dispatch = useDispatch();

  const { userPaymentSubscription, windowRef } = useSelector(
    (state) => state[FEATURE_CUSTOM_PAYMENT]
  );

  const { conferenceJoined } = useSelector(
    (state) => state[FEATURE_CUSTOM_REDUX]
  );


  const handleButtonNames = () => {
    const isPaymentButtonDisabled = getBaseConfig("isPaymentButtonDisabled");

    /**
     * otherwise check for user current subscription and show text accordingly
     * */

    // user current subscription
    const currentSubscription = userPaymentSubscription?.amount / 100;
    const buyNowBtn = ct("rta-trmc.dashboard.subscription.buyNow");
    const upgradeBtn = ct("rta-trmc.dashboard.subscription.upgrade");
    const buttonId = "buyNow";
    const upgradeBtnId = "upgrade";
    // console.log("currentSubscription", currentSubscription)

    // if current subscription is cancelled the show BUY NOW and make button enabled
    if (userPaymentSubscription.is_canceled || userPaymentSubscription.is_expired) {
      return { name: buyNowBtn, isDisabled: false, id: buttonId };
    }

    // if user currrent subscription amount is more than current price then show BUY NOW text and make button enabled
    if (currentSubscription && currentSubscription > props.amount) {
      return { name: buyNowBtn, isDisabled: true, id: buttonId };
    }

    // if user currrent subscription amount is more than current price then show BUY NOW text and make button enabled
    // But if "isPaymentButtonDisabled" key is set to true in constants then make this button enabled
    if (
      currentSubscription &&
      currentSubscription > props.amount
      //  && !isPaymentButtonDisabled
    )
      return { name: buyNowBtn, isDisabled: false, id: buttonId };

    // if user currrent subscription amount is less than current price then show UPGRADE text and make button disabled
    if (currentSubscription && currentSubscription < props.amount)
      return { name: upgradeBtn, isDisabled: false, id: upgradeBtnId };

    // if user currrent subscription amount is equal to current price then show CURRENT text
    if (currentSubscription && currentSubscription == props.amount) {
      if (!checkUserSubscription(null, false)) {
        return { name: buyNowBtn, isDisabled: false, id: buttonId };
      }
      return { name: buyNowBtn, isDisabled: true, id: buttonId };

    }

    // If user don't have any subscription then return from here and show BUY NOW text and make button enabled
    if (!checkUserSubscription(null, false))
      return { name: buyNowBtn, isDisabled: false };

    /* ============== Old code for Subscription Button title Starts ==================*/

    // if (checkUserSubscription(null,false)) {
    //   console.log("check p 2")
    //   const currentPrice = userPaymentSubscription?.amount / 100;
    //   console.log('currentPrice', currentPrice, amount, );
    //   if (currentPrice && currentPrice <= amount) {
    //     console.log("check p 3")

    //     console.log('currentPrice && currentPrice <= amount', currentPrice && currentPrice <= amount);
    //     return { name: "Upgrade", isDisabled: false };
    //   } else {
    //     console.log("check p 4")
    //     const isPaymentButtonDisabled = getBaseConfig(
    //       "isPaymentButtonDisabled"
    //     );

    //     console.log('isPaymentButtonDisabled', isPaymentButtonDisabled)
    //     if (isPaymentButtonDisabled) {
    //       console.log("check p 5")

    //       return { name: "Buy Now", isDisabled: true };
    //     } else {
    //       console.log("check p 6")
    //       return { name: "Buy Now", isDisabled: currentPrice > amount };
    //     }
    //   }
    // }
    // console.log("check p 7")
    // return { name: "Buy Now", isDisabled: false };

    /* ============== Old code for Subscription Button title Ends ==================*/
  };

  const {
    package_id,
    amount,
    name,
    package_type,
    features,
    activePackageId,
    setActivePackageId,
    index,
    plansCount,
    isContentLoading,
    requestFrom,
    showApplyCouponModal
  } = props;

  useEffect(() => {
    if (isLoading && activePackageId !== package_id) {
      setIsLoading(false);
    }
  }, [activePackageId]);

  useEffect(() => {
    // recheck subscription in interval
    if (recheckUserSubscription) {
      let timer = setInterval(function () {
        let _hasSubscription = checkUserSubscription();

        // console.log("checking user subscription ", _hasSubscription, { props });
        if (_hasSubscription) {
          clearInterval(timer);
          setReCheckUserSubscription(false);
          if (props.handleCloseP) {
            props.handleCloseP(true);
          }
          toast(ct("stripeMessage.subscriptionPurchased", "stripeMessage"), 5000);
          if (getBaseConfig("showPreJoiningInConference") && conferenceJoined) {
            setTimeout(() => {
              const { userBoxStaticDeviceId } = getStore(FEATURE_CUSTOM_REDUX_V3);
              const _subscriptionDetail = getStore(FEATURE_CUSTOM_PAYMENT).userPaymentSubscription;
              if (userBoxStaticDeviceId && _subscriptionDetail?.is_premium) {
                dispatch(setShowDevicePreConnection(true));
              }
            }, 1000)
          }
        }
        dispatch(getMySubscription());
      }, 7000);
    }
  }, [recheckUserSubscription]);

  useEffect(() => {
    dispatch(getMySubscription()); // added to get current subscription of user when RCARD loads
    return () => {
      setReCheckUserSubscription(false);
    };
  }, []);

  const handleBuy = (package_id, couponCodeDetail) => {
    if (windowRef?.win?.closed === false) {
      windowRef?.win?.close();
    }
    setActivePackageId(package_id);
    let data = {
      package_id: package_id,
      checkout_session: uuidv4(),
      coupon_code_id: couponCodeDetail?.id,
      stripe_coupon_code: couponCodeDetail?.name,
      lang: i18next.language
      // back_url: window.location.origin
    };

    setIsLoading(true);

    setTimeout(function () {
      setIsLoading(false);
    }, 30000);

    buyPackage(data).then(async (res) => {
      if (res.status == 1) {
        // console.log("received data ", res.data);

        if (res.data.payUrl != undefined) {
          let redir = res.data.payUrl;

          // var w = window.innerWidth;
          // var h = window.innerHeight;
          // var w = window.screen.width * window.devicePixelRatio;
          // var h = window.screen.height * window.devicePixelRatio;

          // var win = window.open(redir, 'newwin', 'height=' + h + '', 'width=' + w + '');
          // var win = window.open(redir);

          var win = handlePaymentWindow(redir);

          if (!win) {
            // to show a confirmation popup only in case when popup's are blocked
            // in mobile or on desktop
            setOpenMobileModal(true);
            setCheckoutUrl(redir);
            setTimeout(() => {
              setOpenMobileModal(false);
              setCheckoutUrl("");
              setIsLoading(false);
            }, 15000);
          }
          setReCheckUserSubscription(true)
          dispatch(
            setWindowReference({
              win,
              uid: data.checkout_session,
              package_id,
            })
          );
        } else {
          let resData = res.data.data;
          // console.log("res data ", resData);
          // toast("Subscription test")
          if (resData.hasOwnProperty("subscriptionUpdated")) {
            // console.log("I have updated subscription 1");
            dispatch(
              setWindowReference({
                win: null,
                uid: null,
                package_id,
              })
            );

            if (conferenceJoined || CURRENT_ROOM_NAME.length > 1) {
              let msg = await dynamicMessageLocale(resData.message);
              toast(msg);

              if (getBaseConfig("showPreJoiningInConference") && conferenceJoined) {
                const { manualBoxProcess } = getStore(FEATURE_CUSTOM_REDUX_V3);
                if (manualBoxProcess.isRunning) {
                  let isAdded = await addDeviceBox({
                    device_id: manualBoxProcess.processData.device_id,
                    user_id: manualBoxProcess.processData.user_id
                  })

                  if (isAdded.status == 1) {
                    localStorage.setItem("uniqueID", manualBoxProcess.processData.device_id);
                    dispatch(setData({
                      uniqueId: manualBoxProcess.processData.device_id,
                    }));
                    setTimeout(() => {
                      dispatch(setShowDevicePreConnection(true))
                      dispatch(setManualBoxProcess({
                        isRunning: false,
                        processData: {}
                      }))
                    }, 1000)
                  }
                } else {
                  const subscriptionDetail = getStore(FEATURE_CUSTOM_PAYMENT).userPaymentSubscription;
                  if(subscriptionDetail?.is_premium){
                    dispatch(setShowDevicePreConnection(true));
                  }
                }
              }
            } else {
              let msg = await dynamicMessageLocale(resData.message);
              dispatch(
                setNotificationMessage({
                  isOpen: true,
                  message: msg,
                  type: NotificationType.SUCCESS,
                })
              );
            }
            dispatch(getMySubscription());
          } else {
            // console.log("I have updated subscription 2");

            if (conferenceJoined || CURRENT_ROOM_NAME.length > 1) {
              toast(ct("rta-trmc.dashboard.subscription.failed"));
            }
            dispatch(
              setNotificationMessage({
                isOpen: true,
                message: ct("rta-trmc.dashboard.subscription.failed"),
                type: NotificationType.ERROR,
              })
            );
            setIsLoading(false);
          }
        }
      } else {
        setIsLoading(false);
        if (conferenceJoined) {
          let msg = await dynamicMessageLocale(res?.message);
          toast(msg || ct("rta-trmc.dashboard.subscription.failed"));
        }

        dispatch(
          setNotificationMessage({
            isOpen: true,
            message: await dynamicMessageLocale(res?.message) || ct("rta-trmc.dashboard.subscription.failed"),
            type: NotificationType.ERROR,
          })
        );
      }
    });
  };

  const checkUserSubscription = (subscription = null, willSet = true) => {
    let hasSubscription = false;

    if (!subscription) {
      subscription = getStore(FEATURE_CUSTOM_PAYMENT).userPaymentSubscription;
    }
    // console.log(
    //   "subscription ",
    //   subscription,
    //   "get subscription pack id  ",
    //   props._id,
    //   "current ",
    //   Math.round(new Date().getTime() / 1000)
    // );
    if (subscription.pack_id) {
      // console.log("check point 2 ");
      if (subscription.pack_id == props._id) {
        // console.log("check point 3 ");

        hasSubscription = true;
        if (subscription.is_canceled == false) {
          // console.log("check point 4 ", subscription.end_at, Math.round(new Date().getTime() / 1000));

          if (subscription.end_at < Math.round(new Date().getTime() / 1000)) {
            // console.log("check point 5 ");

            hasSubscription = false;
          } else {
            // console.log("check point 6 ");

            if (
              subscription.trial_ended &&
              subscription.trial_ended < Math.round(new Date().getTime() / 1000)
            ) {
              hasSubscription = false;
              if (subscription.trial_ended != subscription.end_at) {
                if (subscription.trial_ended < subscription.end_at) {
                  if (subscription.end_at > Math.round(new Date().getTime() / 1000)) {
                    hasSubscription = true;
                  }
                }
              }
              // console.log("check point 7 ");

            } else {
              // console.log("check point 8 ");

              hasSubscription = true;
            }
          }
        } else {
          // console.log("check point 9 ");

          hasSubscription = false;
        }
      }

      if (hasSubscription) {
        if (subscription.is_expired) {
          hasSubscription = false;
        }
      }
      if (willSet) {
        if (isLoading) {
          setIsLoading(false);
        }
      }
    }
    if (willSet) {
      setIsPurchased(hasSubscription);
    }
    return hasSubscription;
  };

  useEffect(() => {
    checkUserSubscription(userPaymentSubscription);
  }, [props?._id, userPaymentSubscription]);

  const handleChange = (panel, isDescriptions) => (event, newExpanded) => {
    if (isDescriptions) {
      setExpanded(newExpanded ? panel : false);
    }
  };

  const handleConfirmAction = (type) => {
    setIsConfirming(false);
    if (type) {
      handleBuy(package_id);
    }
  };
  const clearCustomModal = () => {
    setOpenMobileModal(false);
    setCheckoutUrl("");
    setIsLoading(false);
  };
   
  // if (isContentLoading && requestFrom === "page") {
  //   return null
  // }
  
  return (
    <>
      {openMobileModal && (
        <div>
          <Dialog
            open={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {ct("rta-trmc.dashboard.subscription.allowPayment")}
            </DialogTitle>
            <DialogContent></DialogContent>
            <DialogActions>
              <Button
                id="success"
                style={{ background: "green" }}
                className="media-msg-login"
              >
                <a
                  target="_blank"
                  style={{ color: "white", textDecoration: "none" }}
                  href={checkoutUrl}
                >
                  {ct("rta-trmc.dashboard.subscription.allowBtn")}
                </a>
              </Button>
              <Button
                onClick={() => clearCustomModal()}
                id="cancel"
                style={{ color: "black", textDecoration: "none" }}
                className="media-msg-cancel"
              >
                {ct("Translate.buttonTitle.cancelSmall")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
      {isConfirming && (
        <ConfirmationAlert
          handleConfirmAction={handleConfirmAction}
          title={ct("rta-trmc.dashboard.subscription.upgradeSubscriptionText")}
        />
      )}
      <Grid
        item
        xs={12}
        sm={plansCount > 1 ? 6 : 12}
        md={plansCount > 1 ? 6 : 12}
        lg={plansCount > 1 ? 6 : 12}
      >
        <Card sx={{ border: "1px solid var(--theme-primary-color)" }}>
          <CardHeader
            title={getTranslatedSubsName(name)}
            sx={{
              background: "var(--theme-primary-color)",
              color: "#fff",
              textAlign: "center",
            }}
          />
          <CardContent>
            <Stack
              direction="row"
              spacing={2}
              className="w-100 d-flex justify-content-center"
            >
              <Typography
                sx={{
                  fontSize: "22px !important",
                  fontWeight: "500",
                  color: "#000",
                }}
              >
                ${amount}/
                <span style={{ fontSize: "12px" }}>
                  {package_type == "month" ? ct("rta-trmc.dashboard.subscription.month") : ct("rta-trmc.dashboard.subscription.year")}
                </span>
              </Typography>
            </Stack>
            <Grid container spacing={2}>
              <List
                className="payment-package-list w-100 p-2"
                sx={{
                  height: `calc(100vh - ${cardHeight})`,
                  overflowY: "scroll",
                }}
              >
                {features && features.length ? (
                  features.map((e, i) => {
                    return (
                      <Accordion
                        key={i}
                        expanded={expanded === `panel${i}`}
                        onChange={handleChange(
                          `panel${i}`,
                          e.descriptions?.length
                        )}
                      >
                        <AccordionSummary
                          aria-controls="panel1d-content"
                          id="panel1d-header"
                          expandIcon={
                            expanded === `panel${i}` ? (
                              e.descriptions?.length ? (
                                <i
                                  className="fa fa-minus"
                                  aria-hidden="true"
                                ></i>
                              ) : null
                            ) : e.descriptions?.length ? (
                              <i className="fa fa-plus" aria-hidden="true"></i>
                            ) : null
                          }
                        >
                          {
                            <div className="d-flex">
                              <div>
                                <MuiCheckMark fill="var(--theme-primary-color)" />
                              </div>
                              <Typography>
                                <b>{e.title}</b>
                              </Typography>
                            </div>
                          }
                        </AccordionSummary>
                        {e.descriptions?.length &&
                          e.descriptions.map((data, index) => {
                            return (
                              <AccordionDetails
                                key={index}
                                className={`pt-0 ${index === e.descriptions.length - 1
                                  ? "pb-4"
                                  : "pb-2"
                                  }`}
                              >
                                <Typography sx={{ paddingLeft: "20px" }}>
                                  <span className="d-flex">
                                    <i
                                      className="fa fa-check pr-2"
                                      aria-hidden="true"
                                      style={{
                                        fontSize: "14px",
                                        alignItems: "center",
                                        alignSelf: "center",
                                      }}
                                    ></i>
                                    {data}
                                  </span>
                                </Typography>
                              </AccordionDetails>
                            );
                          })}
                      </Accordion>
                    );
                  })
                ) : (
                  <>
                    <ListItem>
                      <MuiCheckMark fill="var(--theme-primary-color)" />
                      <ListItemText
                        primary="Meetings"
                        secondary="Up to 20 participants"
                      />
                    </ListItem>
                    <ListItem>
                      <MuiCheckMark fill="var(--theme-primary-color)" />
                      <ListItemText
                        primary="RTA Box"
                        secondary="Real time jamming"
                      />
                    </ListItem>
                    <ListItem>
                      <MuiCheckMark fill="var(--theme-primary-color)" />
                      <ListItemText
                        primary="Whiteboard"
                        secondary="Unlimited whiteboard"
                      />
                    </ListItem>
                    <ListItem>
                      <MuiCheckMark fill="var(--theme-primary-color)" />
                      <ListItemText
                        primary="Music Tools"
                        secondary="Explore music tools"
                      />
                    </ListItem>
                  </>
                )}
              </List>
            </Grid>
            <CardActions
              sx={{
                margin: "10px 0",
                p: 0,
              }}
              className="w-100 d-flex justify-content-center"
            >
              <div></div>
              {isPurchased ? (
                <Stack direction="row" spacing={2}>
                  <div className="d-flex flex-column subs-button-wrapper">
                    <Button
                      variant="contained"
                      className="mn-w-110 activated-btn"
                      sx={{
                        fontSize: 14,
                        backgroundColor: "green",
                        backgroundHover: "green",
                      }}
                    >
                      {ct("rta-trmc.dashboard.subscription.current")}
                    </Button>
                    {/* <CouponCodeModal showCoupon={false} /> */}
                  </div>
                </Stack>
              ) : (
                <Stack direction="row" spacing={2}>
                  <>
                    {isLoading ? (
                      <ButtonLoader
                        title={<span>{handleButtonNames().name}</span>}
                      />
                    ) : (
                      <div className={`d-flex flex-column align-items-center subs-button-wrapper`}>
                        <div>
                          <Button
                            id={`buy-btn-${index}`}
                            variant="contained"
                            className="p-theme-btn mn-w-110"
                            sx={{
                              fontSize: 14,
                              cursor: handleButtonNames()?.isDisabled
                                ? "not-allowed"
                                : "default",
                            }}
                            disabled={handleButtonNames()?.isDisabled}
                            onClick={(e) => {
                              if (handleButtonNames().id !== "upgrade") {
                                handleBuy(package_id);
                              } else {
                                let { conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX);
                                if (conferenceJoined) {
                                  dispatch(setConfirmationModalProps({
                                    isShow: true,
                                    type: "conference",
                                    testId: "ask-for-upgrade",
                                    title: ct("Translate.typography.subscription"),
                                    content: ct("rta-trmc.dashboard.subscription.upgradeSubscriptionText"),
                                    onCancel: () => {
                                      dispatch(setConfirmationModalProps({ isShow: false }));
                                    },
                                    onSuccess: () => {
                                      handleConfirmAction(true);
                                      dispatch(setConfirmationModalProps({ isShow: false }));
                                    },
                                    callHideDialog: false,
                                  }));
                                } else {
                                  setIsConfirming(true);
                                }
                              }
                            }}
                          >
                            {handleButtonNames().name}
                          </Button>
                        </div>
                        {!handleButtonNames()?.isDisabled && <CouponCodeModal
                          showCoupon={true}
                          packageId={package_id}
                          type={package_type}
                          package_name={name}
                          handleModalClose={props.handleCloseP}
                          handleBuy={handleBuy}
                          showApplyCouponModal={showApplyCouponModal}
                        />}
                      </div>
                    )}
                  </>
                </Stack>
              )}
            </CardActions>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};
export default RCard;

function CouponCodeModal(props) {
  const { title = ct("rta-trmc.dashboard.subscription.couponCode"), showCoupon, packageId, type, package_name, handleBuy, showApplyCouponModal } = props;
  const [open, setOpen] = useState(showApplyCouponModal);
  const [coupon, setCoupon] = useState(null);
  const [needConfirmation, setNeedConfirmation] = useState(false);
  const [stripeCouponDetail, setStripeCouponDetail] = useState(null);
  const [error, setError] = useState({ isError: false, message: "" });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { conferenceJoined } = useSelector(
    (state) => state[FEATURE_CUSTOM_REDUX]
  );

  const handleClose = (type) => {
    setIsLoading(false);
    setOpen(false);
    setError({ isError: false, message: "" })
  };

  const onApply = async () => {
    setIsLoading(true);
    // console.log("rehit for coupon")
    // setTimeout(function(){
    //   if(isLoading == true){
    //     console.log("loader is stucking resubmi")
    //     onApply()
    //   }
    // },10000)

    let isError = false;
    try {
      if (!coupon) {
        setError({ isError: true, message: ct("rta-trmc.dashboard.subscription.couponCodeValidation") });
        return false;
      }
      const payload = {
        coupon,
        packageId,
        type,
        package_name
      }
      const response = await applyCouponCode(payload);
      const resData = response?.data;
      // stripe coupon exist
      if (resData?.status && resData?.isStripeCoupon) {
        if (resData.isValid) {
          handleBuy(packageId, resData?.stripeCouponDetail);
        } else {
          setStripeCouponDetail({ upgradeToYearPackageId: resData?.upgradeToYearPackageId, stripeCouponDetail: resData?.stripeCouponDetail, message: resData?.message });
          setNeedConfirmation(true);
        }
      } else {
        // stripe coupon not exist continue with manual coupon code
        if (resData.status) {
          dispatch(getMySubscription());
          if (props?.handleModalClose) {
            props.handleModalClose();
          }
          if (getBaseConfig("showPreJoiningInConference") && conferenceJoined) {
            setTimeout(() => {
              const { userBoxStaticDeviceId } = getStore(FEATURE_CUSTOM_REDUX_V3);
              const subscriptionDetail = getStore(FEATURE_CUSTOM_PAYMENT).userPaymentSubscription;
              if (userBoxStaticDeviceId && subscriptionDetail?.is_premium) {
                dispatch(setShowDevicePreConnection(true));
              }
            }, 3000)
          }
          if (conferenceJoined || CURRENT_ROOM_NAME.length > 2) {
            let message = await dynamicMessageLocale(resData.message);
            toast(message)
          } else {
            dispatch(
              setNotificationMessage({
                isOpen: true,
                message: await dynamicMessageLocale(resData.message, 0, false),
                type: NotificationType.SUCCESS,
              })
            );
          }
        } else {
          setError({ isError: true, message: await dynamicMessageLocale(resData.message, 0, false) });
          isError = true;
          // if (conferenceJoined || CURRENT_ROOM_NAME.length > 2) {
          //   toast(resData.message);
          // } else {
          //   dispatch(
          //     setNotificationMessage({
          //       isOpen: true,
          //       message: resData.message,
          //       type: NotificationType.ERROR,
          //     })
          //   );
          // }
        }
      }
    } catch (error) {
      setError({ isError: true, message: ct("rta-trmc.dashboard.subscription.failed") });
      isError = true;
      // if (conferenceJoined || CURRENT_ROOM_NAME.length > 2) {
      //   toast(messages.failed);
      // }else{
      //   dispatch(
      //     setNotificationMessage({
      //       isOpen: true,
      //       message: messages.failed,
      //       type: NotificationType.ERROR,
      //     })
      //   );
      // }
    } finally {
      setIsLoading(false);
      if (coupon && !isError) {
        handleClose(true);
        setCoupon(null);
      }
    }
  };

  const onChange = (e) => {
    if (error.isError) {
      setError({ isError: false, message: "" });
    }
    setCoupon(e.target.value);
  };
  const errorStyle = { marginTop: "0px", color: "var(--theme-error-color)" };


  const onConfirm = (status) => {
    if (status) {
      handleBuy(stripeCouponDetail?.upgradeToYearPackageId, stripeCouponDetail?.stripeCouponDetail);
    } else {
      handleBuy(packageId, null);
      setNeedConfirmation(false);
      setStripeCouponDetail(null);
    }
  }

  if (needConfirmation) {
    return <>
      {
        conferenceJoined || CURRENT_ROOM_NAME.length > 2 ? <GenericConfirmationModal
          isLoading={isLoading}
          onCancel={() => onConfirm(false)}
          onSuccess={() => onConfirm(true)}
          title={ct("Translate.typography.subscription")}
          successBtnName={ct("Translate.buttonTitle.yesSmall")}
          cancelBtnName={ct("Translate.buttonTitle.noSmall")}
          // className="coupon-content"
          content={
            <>
              {stripeCouponDetail?.message}
            </>
          }
        /> : <ConfirmationAlert handleConfirmAction={onConfirm} title={stripeCouponDetail?.message} />
      }
    </>
  }

  return (
    <div className="mt-2" style={{ alignSelf: "center" }}>
      <span
        id="coupon-code-text"
        className="mt-2 coupon-code-link"
        style={{ display: 'block' }}
      >
        {showCoupon ? <>{ct("rta-trmc.dashboard.subscription.enterCouponCodeLink1")} <span onClick={() => setOpen(true)} id="coupon-code-link" className="hyperlink-text coupon-code-link">{ct("rta-trmc.dashboard.subscription.enterCouponCodeLink2")}</span> {ct("rta-trmc.dashboard.subscription.enterCouponCodeLink3")}</> : null}
      </span>
      {conferenceJoined || CURRENT_ROOM_NAME.length > 2 ? (
        open && (
          <GenericConfirmationModal
            isLoading={isLoading}
            onCancel={() => handleClose(false)}
            onSuccess={onApply}
            title={title}
            successBtnName={ct("rta-trmc.dashboard.subscription.apply")}
            cancelBtnName={ct("Translate.buttonTitle.cancelSmall")}
            className="coupon-content"
            content={
              <>
                <label htmlFor="coupon" id="coupon-code">
                  {ct("rta-trmc.dashboard.subscription.couponCode")}:
                </label>
                <input
                  name="coupon"
                  type="text"
                  className="form-control input-control mb-0"
                  id="login-name-field"
                  placeholder={ct("rta-trmc.dashboard.subscription.enterCoupon")}
                  onChange={onChange}
                />
                {error.isError ? (
                  <span style={errorStyle}>
                    {error.message}
                  </span>
                ) : null}
              </>
            }
          />
        )
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="coupon-code-dialog"   // CUSTOM
          style={{ zIndex: 99999 }}
        >
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <TextField
              onChange={onChange}
              className="payment-input"
              id="outlined-basic"
              label={ct("rta-trmc.dashboard.subscription.enterCoupon")}
              variant="filled"
              error={error.isError ? true : false}
              helperText={error.isError ? error.message : ""}
            />
          </DialogContent>
          <DialogActions sx={{ paddingRight: "24px" }}>
            <Button
              onClick={() => handleClose(false)}
              variant="outlined"
              sx={{
                fontSize: 14,
                borderColor: "var(--theme-primary-color)",
                color: "var(--theme-primary-color)",
                "&:hover": {
                  color: "var(--theme-primary-color)",
                  borderColor: "var(--theme-primary-color)",
                },
              }}
            >
              {ct("Translate.buttonTitle.cancelSmall")}
            </Button>
            {isLoading ? (
              <LoadingButton
                style={{ width: "92px" }}
                color="success"
                className="submit-button login-btn-pass join-meeting-pass"
                isLoading
              ></LoadingButton>
            ) : (
              <Button
                onClick={onApply}
                autoFocus
                variant="contained"
                className="p-theme-btn"
                sx={{
                  fontSize: 14,
                  width: "92px"
                }}
              >
                {ct("rta-trmc.dashboard.subscription.apply")}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
